/**
 * Which anchors the SPA's global click router must keep its hands off.
 *
 * The rule lives here rather than inside `main.ts` because importing `main.ts`
 * boots the entire app — there is no way to exercise the rule from a test while
 * it is buried in that listener, and this rule has already shipped wrong once:
 * "the statement PDF reloads the game" was the router calling `preventDefault()`
 * on an `<a download href="blob:...">` and re-rendering the page instead.
 */
export function isBrowserHandledLink(a: HTMLAnchorElement): boolean {
  // A `download` anchor is a save, not a navigation, whatever its href looks like.
  if (a.hasAttribute('download')) return true;
  // Only http(s) is navigable in-app. `blob:` and `data:` carry a generated file to
  // disk, `mailto:`/`tel:` hand off to another app entirely. Note this compares the
  // resolved `protocol`, not the raw href, so a relative "/play" — which resolves to
  // the page's own http(s) origin — still routes.
  return a.protocol !== 'http:' && a.protocol !== 'https:';
}
